import videoDevicesService from "../shared/services/videoDevicesService";

const REQUEST_VIDEO_DEVICES = "REQUEST_VIDEO_DEVICES";
const RESPONSE_VIDEO_DEVICES = "RESPONSE_VIDEO_DEVICES";
const REQUEST_VIDEO_DEVICES_FAILURE = "REQUEST_VIDEO_DEVICES_FAILURE";

const requestGetVideiDevicesAction = () => {
  return {
    type: REQUEST_VIDEO_DEVICES,
  };
};

const responseGetVideiDevicesAction = (data) => {
  return {
    type: RESPONSE_VIDEO_DEVICES,
    data,
  };
};

const requesGetVideiDevicesFailureAction = (errors) => {
  return {
    type: REQUEST_VIDEO_DEVICES_FAILURE,
    errors,
  };
};

const getVideiDevices = (options) => {
  return (dispatch) => {
    dispatch(requestGetVideiDevicesAction());

    videoDevicesService
      .getvideoDevicesIngetrations(options)
      .then((result) => {
        dispatch(responseGetVideiDevicesAction(result.data));
      })
      .catch((error) => {
        dispatch(requesGetVideiDevicesFailureAction(error.response));
      });
  };
};

const REQUEST_VIDEO_DEVICE_CREATE = "REQUEST_VIDEO_DEVICE_CREATE";
const RESPONSE_VIDEO_DEVICE_CREATE = "RESPONSE_VIDEO_DEVICE_CREATE";
const REQUEST_VIDEO_DEVICE_CREATE_FAILURE = "REQUEST_VIDEO_DEVICE_CREATE_FAILURE";

const requestCreateVideiDeviceAction = () => {
  return {
    type: REQUEST_VIDEO_DEVICE_CREATE,
  };
};

const responseCreateVideiDeviceAction = (howenDeviceId, unit) => {
  return {
    type: RESPONSE_VIDEO_DEVICE_CREATE,
    howenDeviceId,
    unit,
  };
};

const requesCreateVideiDeviceFailureAction = (errors) => {
  return {
    type: REQUEST_VIDEO_DEVICE_CREATE_FAILURE,
    errors,
  };
};

const createVideiDevice = (options, unitModel) => {
  return (dispatch) => {
    dispatch(requestCreateVideiDeviceAction());

    videoDevicesService
      .createVideoDevice(options)
      .then((result) => {
        dispatch(responseCreateVideiDeviceAction(options.howenDeviceId, unitModel));
      })
      .catch((error) => {
        dispatch(requesCreateVideiDeviceFailureAction(error.response));
      });
  };
};

const REQUEST_VIDEO_DEVICE_DELETE = "REQUEST_VIDEO_DEVICE_DELETE";
const RESPONSE_VIDEO_DEVICE_DELETE = "RESPONSE_VIDEO_DEVICE_DELETE";
const REQUEST_VIDEO_DEVICE_DELETE_FAILURE = "REQUEST_VIDEO_DEVICE_DELETE_FAILURE";

const requestDeleteVideiDeviceAction = () => {
  return {
    type: REQUEST_VIDEO_DEVICE_DELETE,
  };
};

const responseDeleteVideiDeviceAction = (howenDeviceId) => {
  return {
    type: RESPONSE_VIDEO_DEVICE_DELETE,
    howenDeviceId,
  };
};

const requesDeleteVideiDeviceFailureAction = (errors) => {
  return {
    type: REQUEST_VIDEO_DEVICE_DELETE_FAILURE,
    errors,
  };
};

const deleteVideiDevice = (options, howenDeviceId) => {
  return (dispatch) => {
    dispatch(requestDeleteVideiDeviceAction());

    videoDevicesService
      .deleteVideoDevice(options)
      .then((result) => {
        dispatch(responseDeleteVideiDeviceAction(howenDeviceId));
      })
      .catch((error) => {
        dispatch(requesDeleteVideiDeviceFailureAction(error.response));
      });
  };
};

export {
  REQUEST_VIDEO_DEVICES,
  RESPONSE_VIDEO_DEVICES,
  REQUEST_VIDEO_DEVICES_FAILURE,
  getVideiDevices,
  REQUEST_VIDEO_DEVICE_CREATE,
  RESPONSE_VIDEO_DEVICE_CREATE,
  REQUEST_VIDEO_DEVICE_CREATE_FAILURE,
  createVideiDevice,
  REQUEST_VIDEO_DEVICE_DELETE,
  RESPONSE_VIDEO_DEVICE_DELETE,
  REQUEST_VIDEO_DEVICE_DELETE_FAILURE,
  deleteVideiDevice,
};
